import Vue from "vue"
import axios from "axios"
import {reactive, toRefs, provide, inject} from "@vue/composition-api"

export const state = reactive({})

export const actions = {
    get_payment_token(company_id) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/payment/get_payment_token".format(company_id))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    begin_payment(payload) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/payment/begin_payment".format(payload.company_id), payload)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    change_payment_method(payload) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/payment/change_payment_method".format(payload.company_id), payload)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    retry_charge(payload) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/payment/retry_charge".format(payload.company_id), payload)
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    cancel_payment_subscription(company_id) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/a/{0}/payment/cancel_payment_subscription".format(company_id))
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    },
    initiate_external_subscription(service, company_id) {
        return new Promise(function (resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/{0}/subscription/initiate".format(service, company_id), {company_id: company_id})
                .then(resp => resolve(resp.data))
                .catch(ex => reject(ex))
        })
    }
}

export const getters = {}

export const key = Symbol("PurchaseModule")

export const providePurchase = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    })
}

export default () => inject(key)
